import {useState} from 'react'
import {FormControl} from 'react-bootstrap';

const SearchControl = ({onSearch}) => {

    const [showing, Showing] = useState(false)

    const onChange = (e) => {
        onSearch(e.target.value)
    }

    const onClick = (e) => {
        if(showing)
            onSearch("")
            
        Showing(!showing)
    }

    return (
        <>
        {showing &&       
            <FormControl 
                className="d-inline" 
                style={{ textAlign: 'right', backgroundColor:'lightyellow', width:'6rem', fontWeight:'bold', marginRight:'.6rem' }} 
                name="Search" type="text" 
                defaultValue=""
                onChange={onChange}
                placeholder="بحث" />
        }
        <i className="fa fa-search" onClick={onClick} ></i>

        </>
    )
}

export default SearchControl
